import React from 'react';
import { useSelector } from 'react-redux';

import { PROJECT_STATUS } from '../common/common/project/status';

import Tabs from './common/Tabs';
import { getProjectStatus } from '../reducers/project';

const AppTabs = (props) => {

    const projectStatus = useSelector(state => getProjectStatus(state));

    const handleTabClick = (tabProps) => {
        props.history.push(tabProps.params)
    }

    return (
        <Tabs
            active={props.active}
            onClick={handleTabClick}
        >
            <div
                name="home"
                title="Úvodní stránka"
                iconName="Home"
                params="/"
            />
            <div
                name="view"
                title="Přehled"
                iconName="AppIconDefaultList"
                params={`/projectview/${props.projectId}`}
            />
            {(projectStatus === PROJECT_STATUS.READY.value)
                ? <div
                    name="map"
                    title="Mapa"
                    iconName="Nav2DMapView"
                    params={`/projectmap/${props.projectId}`}
                />
                : null
            }
        </Tabs>

    );
}

export default AppTabs;
